import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useMenuStore } from '../zustand/store/useMenuStore';
import useModalStore from '../zustand/store/useModalStore';
import { useShallow } from 'zustand/shallow';
import useQueryLinkNavigate from '../hooks/useQueryLinkNavigate';

import { useSubIcon } from '../hooks/useSubIcon';
import { useDynamicStyle } from '../hooks/useDynamicStyle';

const TopMenu = ({isSidebarToggle}) => {

    const navigate = useNavigate();
    const { basePath, isHome } = useQueryLinkNavigate();

    const [ menuData, categoryCodes, clickedCategory ] = useMenuStore(useShallow((state) => [state.menuData, state.categoryCodes, state.clickedCategory]));
    const showNotiModal = useModalStore(state => state.showNotiModal);

    // icon list
    const { topIcons } = useSubIcon();
    
    // Dynamic Style Hook
    const { hoverFontColor, fontColor, fontGrayColor, darkBackColor, backColor, lightBorderShadowInColor, lightShadowColor } = useDynamicStyle();
        
    // 뒤로가기 시에도 api 호출 필요
    // 대메뉴 안의 첫 화면으로 간다. 하위 화면이 없는 폴더(MENUSORC 가 순번 숫자)는 건너뛴다
    const naviTop = (menu) => {
        const targetMenu = menu?.menuTree;
        if (!targetMenu) return;

        const firstMenu = targetMenu
            .flatMap(depth1 => [...(depth1.subMenu || []), depth1])
            .find(item => typeof item.MENUSORC === 'string');
        if (!firstMenu) {
            showNotiModal('이용할 수 있는 화면이 없습니다.\n담당자에게 문의해주세요.');
            return;
        }
        navigate(firstMenu.MENUSORC);
    };

    useEffect(() => {
        naviTop();
    }, [basePath])

    // 대메뉴가 하나면 버튼을 가로로 다 채운다. menuData 는 객체라 length 가 없으므로 categoryCodes 로 센다
    const oneTopMenu = categoryCodes?.length < 2;

    return (
        <div className={isHome ? `home_category_wrapper` : `category_wrapper ${backColor} ${lightBorderShadowInColor} ${isSidebarToggle ? 'flex-row' : 'flex-col'}`}>
            {categoryCodes?.map((key) => {
                const menu = menuData[key];
                const selectCategory = menu.SYTMIDNO === clickedCategory ? true : false;
                const homeNStyle = hoverFontColor + (isSidebarToggle ? ' m-auto justify-center gap-1' : ' close_width close_category_padding tooltip_box');
                // top icon 매칭
                const currentTheme = isHome ? 'home' : clickedCategory === 3 ? 'st' : clickedCategory === 21 ? 'tr' : 'mng'
                const topIcon = topIcons[currentTheme][menu.SYTMIDNO];
                return (
                <button key={menu.SYTMIDNO} onClick={() => {naviTop(menu);}}
                    className={isHome ? `home_category ${oneTopMenu ? 'w-full' : 'w-half'}` : `category h_icon_box ${homeNStyle} ${selectCategory ? 'bg_co_white ' + lightShadowColor : ''}`}
                    >
                        {isHome ?
                            <div className={`home_category_title_box`}>
                                {topIcon}
                                <div className='home_title_text'>{menu.SYTMNAME}</div>
                            </div>
                        :
                        <>
                            <div className='icon'>{topIcon?.normal}</div>
                            <div className='hover_icon'>{topIcon?.hover}</div>
                            <div className={`category_title_text ${selectCategory ? fontColor+' extra_bold' : fontGrayColor} ${isSidebarToggle ? 'open_font_size' : ''}`}>{menu.SYTMNAME}</div>
                            {isSidebarToggle ? '' : <span className={`tooltip ${darkBackColor}`}>{menu.SYTMNAME}</span>}
                        </>
                        }
                </button>
                )
            })}
        </div>
    )
}

export default TopMenu